type DateInput = Date | number | string | null | undefined;

function normalizeDateInput(value: DateInput): Date | null {
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? new Date(value.getTime()) : null;
  }
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date : null;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const numeric = Number(trimmed);
    const date =
      Number.isFinite(numeric) && /^-?\d+(\.\d+)?$/.test(trimmed)
        ? new Date(numeric)
        : new Date(trimmed);
    return Number.isFinite(date.getTime()) ? date : null;
  }
  return null;
}

function toTitleCase(value: string): string {
  return value
    .replaceAll(/[_-]+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatDateTime(
  value: DateInput,
  fallback = "Unknown",
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = normalizeDateInput(value);
  if (!date) return fallback;
  return date.toLocaleString(
    [],
    options ?? {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    },
  );
}

export function formatDateOnly(
  value: DateInput,
  fallback = "--",
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = normalizeDateInput(value);
  if (!date) return fallback;
  return date.toLocaleDateString(
    [],
    options ?? {
      month: "short",
      day: "numeric",
      year: "numeric",
    },
  );
}

export function formatTimeOnly(
  value: DateInput,
  fallback = "unknown",
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = normalizeDateInput(value);
  if (!date) return fallback;
  return date.toLocaleTimeString(
    [],
    options ?? {
      hour: "2-digit",
      minute: "2-digit",
    },
  );
}

export function formatFleetHealthReason(value: string | null | undefined): string {
  const text = String(value ?? "").trim();
  return text || "Health details are not available yet.";
}

export function formatFleetRecommendedAction(value: string | null | undefined): string {
  const text = String(value ?? "").trim();
  return text || "No action is recommended right now.";
}

export function formatFleetStatusLabel(value: string | null | undefined): string {
  const text = String(value ?? "").trim();
  return text ? toTitleCase(text) : "Unknown";
}
